module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_8.d1c772ac.pdf";